import * as React from "react";
import {inject} from "mobx-react";

import {ClipsFullscreenController} from "../../../lib/ClipsFullscreenController";

import classes from "./ClipLoadError.styl";
import {Content, ContentsView} from "@ok/common/design-system/components/Content";
import {Button} from "@ok/common/design-system/components/Button";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

interface IClipLoadErrorProps {
    ctrl?: ClipsFullscreenController;
    poster: string
}

export const ClipLoadError: React.FC<IClipLoadErrorProps> = inject("ctrl")((props) => {
    const ctrl = props.ctrl!;

    return (
        <div className={classes["clip-load-error"]}>
            <div className={classes["clip-load-error__spacer"]}></div>
            <ContentsView>
                <ContentsView.Row size={"21b"}>
                    <Content alignmentX={"center"}>
                        <Content.Text view={"primary"}>
                            {l10NPkg.getLMsg("loadError")}
                        </Content.Text>
                    </Content>
                </ContentsView.Row>
                <ContentsView.Row size={"15"}>
                    <Content alignmentX={"center"}>
                        <Content.Text view={"secondary"}>
                            <div className={classes["clip-load-error__suggest"]}>
                                {l10NPkg.getLMsg("loadErrorSuggest")}
                            </div>
                        </Content.Text>
                    </Content>
                </ContentsView.Row>
                <ContentsView.Row size={"21b"}>
                    <Content alignmentX={"center"}>
                        <Button
                            data-tsid={" "}
                            size={"36"}
                            view={"primary"}
                            aria-label={"retry"}
                            onClick={ctrl.handleRetry}
                        >
                            <Button.Label>
                                {l10NPkg.getLMsg("refresh")}
                            </Button.Label>
                        </Button>
                    </Content>
                </ContentsView.Row>
            </ContentsView>
            <div className={classes["clip-load-error__spacer"]}></div>
        </div>
    );
});
